import React from "react";
import styled from "styled-components";
import { FontSize, Spacing, useTheme } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import Icon from "@ui-kit/icon";
import { tr } from "@radarly/i18n";

interface IProps {
  message: string;
  locale: Locale;
}

const Centerer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  flex-direction: column;
  gap: ${Spacing.Medium};
  font-size: ${FontSize.Medium};
`;

const RadarlyCardsLimitsMessage = ({ message, locale }: IProps) => {
  const theme = useTheme();
  return (
    <Centerer>
      <Icon glyph="bang-fat" disk color={theme.message.warning} size={36} />
      {tr(locale, "CARD_LIMIT::" + message)}
    </Centerer>
  );
};

export default RadarlyCardsLimitsMessage;
